import { TemplateElement, html, defineElement, i18n } from '@webtides/element-js';
import '../../../../legacy-library/webcomponents/svg-icon/svg-icon';
import BuyBoxEvents from '../../_buy-box/buy-box/BuyBoxEvents';
import '../../../elements/show-hide/show-hide';
import styles from './product-variant-specs.css';

export default class ProductVariantSpecs extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            variant: undefined,
            specs: [],
            initiallyVisible: 6,
            collapsing: false,
            collapsed: true,
            showFadeOut: true,
            cssClasses: {},
        };
    }

    get enabledSpecs() {
        if (this.specs.length > 0) {
            const enabledSpecs = [];
            this.specs.forEach(key => {
                if (key in this.variant.specs) {
                    enabledSpecs.push(this.variant.specs[key]);
                }
            });
            return enabledSpecs;
        } else {
            return Object.values(this.variant.specs);
        }
    }

    events() {
        return {
            document: {
                [BuyBoxEvents.VARIANT_CHANGE]: ({ detail: selectedVariant }) => {
                    this.variant = selectedVariant;
                },
            },
            '[btn-toggle]': {
                click: () => {
                    this.collapsed = !this.collapsed;
                },
            },
        };
    }

    get buttonCssClasses() {
        return this.cssClasses.btnCssClasses || 'btn btn-outline-dark';
    }

    template() {
        if (!this.variant) return html``;

        return html`
            <p class="sku-label">${i18n('ITEM_NUMBER')} ${this.variant.sku}</p>

            ${this.collapsing
                ? html`
                      <show-hide
                          fade-out="${this.showFadeOut}"
                          class="spec-table"
                          row-selector=".spec-row"
                          initially-visible="${this.initiallyVisible}"
                          open="${this.collapsed === true ? 'false' : 'true'}"
                      >
                          <div slot="content">${this.templateContent()}</div>
                      </show-hide>

                      <div class="text-center">
                          ${this.collapsed
                              ? html`
                                    <button btn-toggle class="${this.buttonCssClasses} mt-4">
                                        <span>${i18n('DISPLAY_FURTHER_DATA')}</span>
                                        <svg-icon name="arrow-down" class="h-3 w-3"></svg-icon>
                                    </button>
                                `
                              : html`
                                    <button btn-toggle class="${this.buttonCssClasses} mt-4">
                                        <span>${i18n('DISPLAY_LESS_DATA')}</span>
                                        <svg-icon name="arrow-up" class="h-3 w-3"></svg-icon>
                                    </button>
                                `}
                      </div>
                  `
                : html` <div class="max-w-screen-md spec-table mx-auto">${this.templateContent()}</div> `}
        `;
    }

    templateContent() {
        return html`
            ${this.enabledSpecs.map(
                (spec, index) =>
                    html`
                        <div class="spec-row row no-gutters ">
                            <div class="spec-label-col col w-full md:w-4/12 md:ml-1/12">
                                <span class="spec-label">${spec.attributeLabel}</span>
                            </div>
                            <div class="spec-value-col col w-full md:w-6/12 md:ml-1/12">
                                <span class="spec-value">${spec.value}</span>
                            </div>
                        </div>
                    `
            )}
        `;
    }
}
